import { UnitGroupsActionsUnion } from '../actions/unit-groups.actions';
import { getUnitGroupsSuccess, getUnitGroupsFailure, UnitGroupsApiActionsUnion } from '../actions/unit-groups-api.actions';
import { UnitGroups } from '../../../units/models/unit-groups';
import * as UnitSharedActions from '../actions/units-shared.actions';

export interface State {
  unitGroups: UnitGroups[] | null;
}

export const initialState: State = {
  unitGroups: [],
};

export function reducer(
  state = initialState,
  action: UnitGroupsActionsUnion | UnitGroupsApiActionsUnion | UnitSharedActions.UnitsSharedActionsUnion
): State {
  switch (action.type) {
    case getUnitGroupsSuccess.type: {
      return {
        ...state,
        unitGroups: action.unitGroups
      };
    }
    case getUnitGroupsFailure.type: {
      return {
        ...state,
        unitGroups: null
      };
    }
    case UnitSharedActions.clearData.type: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}
export const getUnitGroups = (state: State) => state.unitGroups;
